console.log('single-events.js');

// Image mise en avant fixée au scroll (écrans + 992px)
document.addEventListener("DOMContentLoaded", function () {
    const thumbnailBlock = document.querySelector(".single-event__thumbnail-wrapper");
    const eventHeaderLeft = document.querySelector(".single-event__header-left");
    const eventHeader = document.querySelector(".single-event__header");
    const eventHeaderHeight = eventHeader.offsetHeight;

    if (thumbnailBlock) {

        if (window.innerWidth > 991) {

            let is_sticky = false;

            const positionFixed = thumbnailBlock.getBoundingClientRect().top + window.scrollY;
            const thumbnailBlockHeight = thumbnailBlock.offsetHeight;
            const thumbnailBlockBtnsHeight = document.querySelector(".single-event__thumbnail-btns").offsetHeight;
            const thumbnailBlockTotalHeight = thumbnailBlockHeight + thumbnailBlockBtnsHeight;

            const breadcrumbHeight = document.querySelector(".breadcrumb").offsetHeight;
            const eventMainHeight = document.querySelector(".single-event__main").offsetHeight;

            document.addEventListener("scroll", function () {

                const siteHeader = document.querySelector(".site-header.site-header--sticky");
                const siteHeaderHeight = siteHeader.offsetHeight + 25;
                const fullHeight =  breadcrumbHeight + eventHeaderHeight + eventMainHeight + siteHeaderHeight;

                console.log("Hauteur du bloc: " + thumbnailBlockHeight);

                if (window.scrollY + siteHeaderHeight + thumbnailBlockTotalHeight - fullHeight > 0) {
                    thumbnailBlock.classList.remove("is-fixed");
                    thumbnailBlock.classList.add("position-fixed-footer");
                    eventHeaderLeft.style.height = thumbnailBlockHeight + "px";

                    is_sticky = false;

                    if (eventHeader) {
                        eventHeader.style.position = "static";
                    }
                }

                if (!is_sticky && positionFixed <= window.scrollY + siteHeaderHeight && window.scrollY + siteHeaderHeight + thumbnailBlockTotalHeight - fullHeight < 0) {
                    thumbnailBlock.classList.add("position-fixed");
                    thumbnailBlock.classList.remove("position-fixed-footer");
                    eventHeaderLeft.style.height = thumbnailBlockHeight + "px";

                    is_sticky = true;

                    if (eventHeader) {
                        eventHeader.style.position = "relative";
                    }

                } else if (is_sticky && positionFixed > window.scrollY + siteHeaderHeight) {
                    thumbnailBlock.classList.remove("position-fixed");
                    is_sticky = false;
                    
                    if (eventHeader) {
                        eventHeader.style.position = "relative";
                    }
                }

            });
        }
    }
})